import { Answers } from "../../UserJourney/UserJourneyMap";

// Women's Health
//
// Rated on the symptom-impact question alone. Life stage never affects the rating: the
// recommendation copy is written to hold for every life stage, so it only needs the impact.
// - minimal: None or Mild
// - moderate: Moderate
// - significant: Severe

const totalRiskLevel = 3;

const WomensHealthGuidelineDefinition = [
    { key: "significant", label: "ranges.significant_impact", riskLevel: 3 / totalRiskLevel },
    { key: "moderate", label: "ranges.moderate_impact", riskLevel: 2 / totalRiskLevel },
    { key: "minimal", label: "ranges.minimal_impact", riskLevel: 1 / totalRiskLevel }
];

const WomensHealthGuidelineDisplayOrder = [...WomensHealthGuidelineDefinition].sort(
    (a, b) => b.riskLevel - a.riskLevel
);

const RATING_BY_ANSWER = {
    [Answers.womensHealth.symptomNone]: "minimal",
    [Answers.womensHealth.symptomMild]: "minimal",
    [Answers.womensHealth.symptomModerate]: "moderate",
    [Answers.womensHealth.symptomSevere]: "significant"
};

// Choice answers are stored as their English labels, so the lookup is on that text.
const RATING_BY_NORMALISED_ANSWER = Object.keys(RATING_BY_ANSWER).reduce(
    (byAnswer, answer) => ({ ...byAnswer, [answer.toLowerCase()]: RATING_BY_ANSWER[answer] }),
    {}
);

/**
 * @param {string} symptomImpact - the stored answer to WOMENS_HEALTH_SYMPTOM_IMPACT
 * @returns {{ key: string, label: string, riskLevel: number } | null}
 */
function womensHealth(symptomImpact) {
    if (symptomImpact == null) return null;

    const key =
        RATING_BY_NORMALISED_ANSWER[
            String(symptomImpact)
                .trim()
                .toLowerCase()
        ];
    return WomensHealthGuidelineDefinition.find(def => def.key === key) || null;
}

const RiskName = "Women's Health";
const RiskCode = "WOMENS_HEALTH";
const GuidelineName = "SiSU Women's Health Guideline";
const GuidelineCode = "SISU_WOMENS_HEALTH";

export {
    womensHealth,
    WomensHealthGuidelineDefinition,
    WomensHealthGuidelineDisplayOrder,
    RiskName,
    RiskCode,
    GuidelineName,
    GuidelineCode
};
